import axiosInstance from '../axiosInterceptor/axiosInstance'

const resendInvitation = async ({ orgId, invitationId }) =>
  axiosInstance.post(`v1/orgs/${orgId}/invitations/${invitationId}/resend`)

export default resendInvitation
